import { DotLottie } from '@lottiefiles/dotlottie-web';

const canvas = document.querySelector('#dotlottie-canvas');

if (canvas) {
  const src = canvas.getAttribute('data-src');
  const dotLottie = new DotLottie({
    autoplay: true,
    loop: true,
    canvas: canvas,
    src: src, 
  });
} else {
  console.error('Element #dotlottie-canvas not found');
}